/* DISPRO: 'Opties kiezen' navigeert direct naar de productpagina i.p.v. een quick-add modal te openen. De custom productsectie (dispro-custom-product) bevat geen <product-info>-element, waardoor de standaard modal niet werkt. */
if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      show(opener) {
        const url = opener.getAttribute('data-product-url');
        if (url) {
          window.location.href = url;
          return;
        }
        const link = this.closest('.card-wrapper')?.querySelector('a[href*="/products/"]');
        if (link) window.location.href = link.getAttribute('href');
      }
    }
  );
}
